<template>
  <div class="page-content">
    <page-template
      ref="recycleGoods"
      :tableOptions="tableOptions"
      :toolConfig="toolConfig"
      :searchOptions="searchOptions"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';

  export default {
    components: {
      pageTemplate

    },
    data() {
      return {
        dialogVisibility: false,
        // 更多功能
        toolConfig: [
          {
            label: '批量商品还原',
            code: 'goodsReduction',
            callback: this.batchGoodsReduction
          },
        ],
        // 高级搜索条件
        searchOptions: {
          simple: [
            {label: '', prop: 'otherName', type: 'input', isFuzzy: true, placeholder: "请输入商品条码/自编码/名称", width: "150"},
          ]
        },
        // 表格信息配置
        tableOptions: {
          indexShow: true,//是否显示索引
          showSelect: true,
          param: {status: 99, specsStatus: 99},
          columns: [
            {label: '图片', prop: 'goodsImageUrl', width: '120', align: 'center', type: 'image'},
            {label: '条码', prop: 'barCode', width: '150', align: 'center'},
            {label: '自编码', prop: 'artNo', width: '120', align: 'center'},
            {label: '商品名称', prop: 'name', width: '120', align: 'center'},
            {label: '单位', prop: 'unitName', width: '120', align: 'center'},
            {label: '商品类型', prop: 'pricingMethod', width: '120', align: 'center'},
            {label: '商品类别', prop: 'goodsCategoryName', width: '120', align: 'center'},
            {label: '供应商', prop: 'supplierName', width: '190', align: 'center'},
            {label: '品牌', prop: 'goodsBrandName', width: '120', align: 'center'},
            {
              label: '计价方式',
              prop: 'pricingMethod',
              width: '120',
              align: 'center',
              enumData: this.$utils.getCacheStatus('asGoods.pricingMethod')
            },
            {label: '进货价', prop: 'buyPrice', width: '120', align: 'center'},
            {label: '零售价', prop: 'retailPrice', width: '120', align: 'center'},
            {label: '会员价', prop: 'vipPrice', width: '120', align: 'center'},
            {label: '批发价', prop: 'tradePrice', width: '120', align: 'center'},
            {label: '配送价', prop: 'deliveryPrice', width: '120', align: 'center',},
            {
              label: '商城销售', prop: 'openMall', width: '120', align: 'center',
              type: 'switch', change: this.deliveryTypeChange,
              activeValue: true, inactiveValue: false
            },
            {
              label: '状态信息', prop: 'openMall', width: '120', align: 'center',
              type: 'switch', change: this.deliveryTypeChange,
              activeValue: true, inactiveValue: false
            },
            {
              label: '线下折扣', prop: 'offlineDiscount', width: '120', align: 'center',
              type: 'switch', change: this.deliveryTypeChange,
              activeValue: true, inactiveValue: false
            },
            {
              label: '线上折扣', prop: 'onlineDiscount', width: '120', align: 'center',
              type: 'switch', change: this.deliveryTypeChange,
              activeValue: true, inactiveValue: false
            },
            {
              label: '允许赠送', prop: 'give', width: '120', align: 'center',
              type: 'switch', change: this.deliveryTypeChange,
              activeValue: true, inactiveValue: false
            },
            {
              label: '允许积分', prop: 'generateIntegral', width: '120', align: 'center',
              type: 'switch', change: this.deliveryTypeChange,
              activeValue: true, inactiveValue: false
            },
            {label: '积分', prop: 'integral', width: '120', align: 'center',},
            {
              label: '参与营业员提成', prop: 'give', width: '150', align: 'center',
              type: 'switch', change: this.deliveryTypeChange,
              activeValue: true, inactiveValue: false
            },

          ],
          url: api.archives.goodsInfo
        },
      };
    },
    created() {
    },
    methods: {
      batchGoodsReduction() {
        let goodsList = this.$refs.recycleGoods.getTableSelectRow();
        let ids = [];
        if (goodsList.length === 0) {
          this.$message({message: "请勾选数据后进行批量还原商品！", type: "warning"});
        } else {
          goodsList.map(item => {
            ids.push(item.id);
          });
          this.$confirm('确定还原选择的商品?', '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
            this.$axios.fetchPost(api.archives.goodsReduction, {asGoodsList: goodsList, ids: ids}).then(data => {
              if (data.code === 200) {
                this.$notify({
                  type: "success",
                  title: '批量还原商品操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: "批量还原商品成功!", type: "success"});
                this.$refs.recycleGoods.$refs.tableTemp.getTableData()
              } else {
                this.$message({message: "批量还原商品失败!", type: "error"});
              }
            });
          });
        }
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/archives/goods/Recycle.vue